import { render, staticRenderFns } from "./BusinessUnits.vue?vue&type=template&id=c3b0dd3c&scoped=true&"
import script from "./BusinessUnits.vue?vue&type=script&lang=js&"
export * from "./BusinessUnits.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUnits.vue?vue&type=style&index=0&id=c3b0dd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b0dd3c",
  null
  
)

export default component.exports